var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v(_vm._s(_vm.$i18n.gt('HEADING_PAGE_NOT_FOUND')))])])}
var staticRenderFns = []

export { render, staticRenderFns }